import { FormProvider } from 'react-hook-form';

import { CredentialsForm } from '../../components/credentials-form';
import { useRegisterResult } from './providers/register.provider';

export const RegisterForm = () => {
  const { methods, handleSubmit } = useRegisterResult();

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <CredentialsForm
          usernameLabel={'New username'}
          validateUsername
          buttonText={'Register'}
        />
      </form>
    </FormProvider>
  );
};
